import { render, staticRenderFns } from "./EditSuper.vue?vue&type=template&id=679e5fce&scoped=true&"
import script from "./EditSuper.vue?vue&type=script&lang=js&"
export * from "./EditSuper.vue?vue&type=script&lang=js&"
import style0 from "./EditSuper.vue?vue&type=style&index=0&id=679e5fce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e5fce",
  null
  
)

export default component.exports